var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  strokeWidth: 0,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.477 3.737a.75.75 0 0 1-.022 1.06L7.2 10.792a.76.76 0 0 1-1.052 0L3.417 8.173A.75.75 0 0 1 4.455 7.09l2.22 2.128 5.742-5.503a.75.75 0 0 1 1.06.022",
  clipRule: "evenodd"
})));
export default SvgSent;